import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton,
  ModalFooter, Input, Text, Button, VStack, 
} from "@chakra-ui/react";


const OTPModal = ({ isOpen, onClose, handleResendOtp, handleOtpSubmit, timeLeft, resendLoading, otp, setOtp, verified, setOtpModalOpen, isLoading, title = "OTP Verification" }) => {

  return (
      <Modal isOpen={isOpen} onClose={onClose} isCentered size="sm">
        <ModalOverlay />
        <ModalContent p={6} borderRadius="md">
          {!verified ? (
            <>
              <ModalHeader>{title}</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <VStack align="start" spacing={4}>
                  <Text>Enter OTP sent to phone number 
                    {/* <strong>{email || "N/A"}</strong> */}
                    </Text>
                  <Input
                    placeholder="Enter OTP"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                  />
                  {timeLeft > 0 ? (
                    <Text fontSize="sm" color="gray.500">
                      Resend OTP in {timeLeft} secs
                    </Text>
                  ) : (
                    <Text fontSize="sm">
                      Didn’t receive code?{' '}
                      <Button size="xs" variant="link" isLoading={resendLoading} onClick={handleResendOtp}>
                        Resend
                      </Button>
                    </Text>
                  )}
                </VStack>
              </ModalBody>
              <ModalFooter justifyContent="center">
                <Button
                  colorScheme="red"
                  onClick={handleOtpSubmit}
                  isDisabled={otp.length !== 6}
                  isLoading={isLoading}
                >
                  Verify OTP
                </Button>
              </ModalFooter>
            </>
          ) : (
            <ModalBody textAlign="center">
              <VStack spacing={4}>
                <Text fontSize="2xl" color="green.500">✅ Verified</Text>
                <Button colorScheme="red" onClick={() => setOtpModalOpen(false)}>OK</Button>
              </VStack>
            </ModalBody>
          )}
        </ModalContent>
      </Modal>
  );
};

export default OTPModal;
